// Справочник марка стали
// src/components/Directory/DirectorySteelGrade.js
import React, { useState } from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CRow,
  CCol,
  CFormInput,
  CTable,
  CTableHead,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell
} from '@coreui/react';

import AddSteelGradeForm from './AddSteelGradeForm';

const DirectorySteelGrade = ({ visible, onClose }) => {
  // Состояние для видимости модального окна добавления
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);

  // Функция для открытия модального окна добавления
  const openAddModal = () => {
    setIsAddModalVisible(true);
  };

  // Функция для закрытия модального окна добавления
  const closeAddModal = () => {
    setIsAddModalVisible(false);
  };

  const handleSaveNewGrade = (newGradeData) => {
    console.log("Новая марка стали для добавления:", newGradeData);
    closeAddModal();
  };

  // TODO: Замените этот пример данных на данные из API или состояния
  const exampleData = [
    // ... ваши данные ...
  ];

  return (
    <>
      <CModal
        alignment="start"
        size="xl"
        visible={visible}
        onClose={onClose}
        backdrop="static"
      >
        <CModalHeader>
          <CModalTitle>Справочник: Марка стали</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CRow className="mb-3 align-items-center gx-2"> 
            <CCol xs="auto">
              <CButton color="primary" size="sm" onClick={openAddModal}>Добавить</CButton>
            </CCol>
            <CCol xs="auto">
              <CButton color="secondary" size="sm">Редактировать</CButton>
            </CCol>
            <CCol xs="auto">
              <CButton color="danger" size="sm">Удалить</CButton>
            </CCol>
            <CCol xs="auto">
              <CButton color="secondary" size="sm">Поиск</CButton>
            </CCol>
            {/* Изменено: xs="3" вместо xs (который занимал оставшееся пространство) */}
            <CCol xs="3"> 
              <CFormInput
                type="text"
                placeholder="Поиск..."
                size="sm"
                // value={searchTerm}
                // onChange={(e) => setSearchTerm(e.target.value)}
              />
            </CCol>
          </CRow>

          {/* Таблица данных */}
          <CTable striped bordered hover responsive>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell>Марка стали</CTableHeaderCell>
                <CTableHeaderCell>ГОСТ, ТУ</CTableHeaderCell>
                <CTableHeaderCell>Толщина проката, мм или разряд толщин</CTableHeaderCell>
                <CTableHeaderCell>Мин. временное сопротивление, кгс/см2</CTableHeaderCell>
                <CTableHeaderCell>Мин. предел текучести, МПа</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {exampleData.length > 0 ? (
                exampleData.map((item) => (
                  <CTableRow key={item.id /* или уникальный ключ */}>
                    <CTableDataCell>{item.steelGrade}</CTableDataCell>
                    <CTableDataCell>{item.gostTu}</CTableDataCell>
                    <CTableDataCell>{item.thickness}</CTableDataCell>
                    <CTableDataCell>{item.minTensileStrength}</CTableDataCell>
                    <CTableDataCell>{item.minYieldStrength}</CTableDataCell>
                  </CTableRow>
                ))
              ) : (
                <CTableRow>
                  <CTableDataCell colSpan="5" className="text-center">
                    Нет данных для отображения
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={onClose}>
            Закрыть
          </CButton>
        </CModalFooter>
      </CModal>

      <AddSteelGradeForm
        visible={isAddModalVisible}
        onClose={closeAddModal}
        onSave={handleSaveNewGrade}
      />
    </>
  );
};

export default DirectorySteelGrade;